import React from 'react'
import styled from 'styled-components'

import {
  CandidateStages,
  StageIcon,
} from 'components/styled/icon/candidate-stage/stage-icon'
import { connect } from 'react-redux'
import { I18nComponentType } from 'admin/i18n-types'
import { mapLanguageToComponentProps } from 'admin/i18n'
import { Body } from '../typography'

export interface CandidateStageProps {
  i18n: I18nComponentType
  stage: CandidateStages
  customStage?: {
    currStageNum: number
    numOfStages: number
    name: string
  }
  wrapping?: boolean
}

export const StyledCandidateStage = styled.div`
  display: flex;
  align-items: center;
  overflow: hidden;
  text-overflow: ellipsis;
`

const CandidateStageFC: React.FC<CandidateStageProps> = ({
  i18n,
  stage,
  customStage,
  wrapping = false,
}) => {
  return (
    <StyledCandidateStage>
      <StageIcon stage={stage} customStage={customStage} />
      <Body
        mr="s8"
        ml="s8"
        ellipsis
        whiteSpace={wrapping ? 'normal' : 'nowrap'}
      >
        {(stage !== CandidateStages.Custom && i18n.status.person[stage]) ||
          customStage?.name}
      </Body>
    </StyledCandidateStage>
  )
}

export const CandidateStage = connect<{
  i18n: I18nComponentType
}>(mapLanguageToComponentProps())(CandidateStageFC)
